export default "__VITE_ASSET__DdliORFS__"